function getDevice(){
    var devString =  $('#device').css('marginLeft');
    var str = devString.replace(/px/g,'');
    return str;
}


function searchBtn(){
    if(!$('.search').is(":visible")){
        $('.srchBtn').on('click', function(){
            $('.searchCont').toggleClass('showSrch');
          	$('.search_box').focus();
        });
    }
};

$( document ).ready(function() {
 
    $('#mainNav16').mmenu({}, {
        // configuration
         clone: true
      });
  
    //$('#mm-mainNav16  ul > li.title span').each(function(index){
        //var className ;
        //switch ($(this).text().toLowerCase()){
            //case 'sale': 
            //className= 'saleIcon';
            //break;
            //case 'racquets': 
            //className= 'racIcon';
            //break;
            //case 'apparel': 
            //className= 'appaIcon';
            //break;
            //case 'footwear': 
            //className= 'footIcon';
            //break;
            //case 'strings': 
            //className= 'striIcon';
            //break;
            //case 'bags & accessories': 
            //className= 'acceIcon';
            //break;
            //case 'services': 
            //className= 'serIcon';
            //break;
            //case 'balls & court equipment': 
            //className= 'courIcon';
            //break;

            //default:
            //className = 'appaIcon';

        //}
      //  $(this).parent().prepend('<span class="icon '+ className + '"></span>');
    //});

   // /  {% comment %}
    // $('.navBtn').click(function(){
    //     if(!$(this).hasClass('opened')){
    //         $(this).addClass('opened')
    //     	     $('.menuBtn img').attr('src',"{{ 'hambCLIcon.png' | asset_url }}");
    //     }
    //     else{

    //          $(this).removeClass('opened')
    //          $('.menuBtn img').attr('src',"{{ 'hambIcon.png' | asset_url }}");


    //     }
    // });
    // $('#mm-blocker').click(function(){
    //          $('.navBtn ').removeClass('opened')
    //      $('.menuBtn img').attr('src',"{{ 'hambIcon.png' | asset_url }}");

    // });
    // {% endcomment %} 

    searchBtn();
    
    var currentDev = getDevice();
    
    $(window).resize(function(){
       
        if(currentDev!= getDevice()){
            
            if(getDevice() == "1")
            {
            searchBtn();
           
            }
            else if(getDevice() == "2"){
             searchBtn();
            }
            else{
                $(".showSrch").removeClass('showSrch');
                $('.srchBtn').off('click');

            }

            currentDev = getDevice();
        }

    });
  






})

